import React from 'react'
import RouterHook from '../../../contexts/RouterHook'
import { HiArrowPath } from 'react-icons/hi2'
import { Services } from '../../../services'
import moment from 'moment'

import './stylesCMens.css'

export default function CompMensalista({ mens }) {
  const serverRouter = RouterHook()
  /* -- padrão de cores! -- 
      colorSolicitado: '#ff7043',
      colorReservado: '#24ad49',
      colorRealizado: '#00cda4',
      colorCancelado: '#bf3324',
  */

  function ReturnColorStatus(status) {
    switch (status) {
      case 'Solicitado':
        return '#ff7043'
      case 'Agendado':
        return '#22ac4a'
      case 'Rejeitado':
        return '#bf3324'
      case 'Cancelado':
        return '#bf3324'
      case 'Realizado':
        return '#00cda4'
    }
  }

  function RetornaStatus(status) {
    switch (status) {
      case 'Solicitado':
        return 'SOLICITADO'
      case 'Agendado':
        return 'AGENDADO'
      case 'Rejeitado':
        return 'REJEITADO'
      case 'Cancelado':
        return 'CANCELADO'
      case 'Realizado':
        return 'REALIZADO'
    }
  }

  return (
    <button
      className={'btt-comp-mensalista'}
      onClick={() => {
        serverRouter('mensalista', mens.idmensalista)
      }}
    >
      <div className='contain-btt-mensalista-infos left-mensalista'>
        <h2 className='title-comp-hora-fixa'>
          {`Horário Fixo ${mens.tipoMensalista !== null ? (mens.tipoMensalista === 'Indeterminado' ? 'Sem Fim' : mens.tipoMensalista) : ''}`}
        </h2>
        <div className='left-mensalista-div'>
          <HiArrowPath size={20} color={'#ff7043'} />
          <h3>{Services.ReturnDiaSemana(4, new Date(mens.dataPrimeiraReserva)).toUpperCase()}</h3>
        </div>
        {mens.pedidos.length > 0 ? (
          <h2 className='title-comp-hora-fixa' style={{ fontSize: '18px' }}>
            {mens.pedidos &&
              `${Services.ReturnHoraMin(new Date(mens.pedidos[0].dataInicio))} às ${Services.ReturnHoraMin(new Date(mens.pedidos[0].dataFinal))}`}
          </h2>
        ) : null}
        {mens.tipoMensalista !== null && mens.tipoMensalista !== 'Indeterminado' ? (
          <h4>{`${Services.DataFormat('DD/MM/YY', mens.dataPrimeiraReserva)} à ${Services.DataFormat('DD/MM/YY', mens.dataUltimaReserva)}`}</h4>
        ) : (
          <h4>{`Começou em ${moment(mens.dataPrimeiraReserva).format('DD/MM/YY')}`}</h4>
        )}
        <h3 style={{ color: ReturnColorStatus(mens.statusSolicitacao), fontFamily: 'jost-mediun' }}>{RetornaStatus(mens.statusSolicitacao)}</h3>
      </div>
      <div className='contain-btt-mensalista-infos right-mensalista'>
        <h3 style={{ fontWeight: 'bold', fontFamily: 'var(--font-jost-mediun)', textAlign: 'right' }}>{`${mens.quadra.descricao}`}</h3>
        {mens.tipoMensalista !== 'Indeterminado' &&
          (mens.valorDescontoCupom > 0 ? (
            <h4>{`Total R$${(mens.valorTotal - mens.valorDescontoCupom).toFixed(2).replace('.', ',')}`}</h4>
          ) : (
            <h4>{`Total R$${
              mens.valorAtualizado ? mens.valorAtualizado.toFixed(2).replace('.', ',') : mens.valorTotal.toFixed(2).replace('.', ',')
            }`}</h4>
          ))}
        {mens.tipoMensalista !== 'Indeterminado' && mens.valorRealizado > 0 && (
          <h4>{`Pago R$${mens.valorRealizado.toFixed(2).replace('.', ',')}`}</h4>
        )}
      </div>
    </button>
  )
}
